<template>
  <div>
    <h2>Section 2</h2>
    <p>This is Section 2 of the Home page.</p>
  </div>
</template>

<script>
export default {
  name: 'Section2'
}
</script>